// src/components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user, authLoading } = useAuth();

  if (authLoading) {
    return <div className="p-6">Checking authentication...</div>;
  }

  return user ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
